import styled, { css } from 'styled-components'

import { MediaPlayerButton } from './MediaPlayerButton'

export const CaptionsButton = styled(MediaPlayerButton)<{ $active?: boolean }>`
  ${({ $styles, $active }) =>
    $styles?.activeCC &&
    $active &&
    css`
      color: ${$styles.activeCC.color};
    `}
`
